import * as React from "react";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { FirmInstructionHistoryCollectionModel } from "../../../../Wrap/Models/Models/Company/FirmInstructionHistoryCollectionModel";
import { NetworkAction } from "../Actions/NetworkAction";
import { NetworkStore } from "../Stores/Variable";
import { Dictionary } from "../../../../react-core/Helpers/CommonHelper";
import { InstructionStatus } from "../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { SelectEditor } from "../../../../react-core/Html/SelectEditor";
import { NetworkType } from "../../../../Wrap/Constants/Enums/Network/NetworkType";
import { Navigator } from "../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../Dashboard/Urls";
import { NetworkFilterDashboard } from "./NetworkFilterDashboard";
import { NetworkProcessType } from "../../../../Wrap/Constants/Enums/Network/NetworkProcessType";
import { NetworkHistoryTable } from "./NetworkHistoryTable";
import { NetworkHistoryModel } from "../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { checkPermission } from "../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";
import { UserClient } from "../../../../Wrap/Api/User/User";
import { IndividualUserFunctionClient } from "../../../../Wrap/Api/User/IndividualUserFunction";
import { UserStore } from "../../../Dashboard/Stroes/Variable";

export type INetworkDashboardProps = React.Props<NetworkDashboard>;

interface INetworkDashboardState {
    tableData: FirmInstructionHistoryCollectionModel;
    isLoading?: boolean;
    currentPage: number;
    filter: any;
    createType: NetworkType;
    selectNetwork: NetworkHistoryModel;
    hasNetworkPermission: boolean;
}

export class NetworkDashboard extends FormComponent<INetworkDashboardProps, INetworkDashboardState> {
    constructor(props: INetworkDashboardProps) {
        super(props);
        this.state = {
            tableData: null,
            isLoading: false,
            currentPage: 1,
            createType: null,
            selectNetwork: null,
            filter: {
                Statuses: [InstructionStatus.Complete],
                NetworkType: 0,
                NetworkName: "",
                TradingReference: "",
                PostCode: "",
                Count: 10,
            },
            hasNetworkPermission: false,
        };
        this.subscribeToStore(NetworkStore, () => this.onNetworkStoreChange());
    }

    componentDidMount() {
        const clientId = UserStore.getUserInfo().ClientId;

        if (clientId == null || clientId == 0) {
            const client = new UserClient();
            const promise = client.get();

            promise.onSuccess((result) => {
                this.checkNetworkPermission(result.ClientId);
            });
            promise.onError((err) => {});
        } else {
            this.checkNetworkPermission(clientId);
        }
    }

    public checkNetworkPermission(clientId: number) {
        const FunctionName = "CanModifyNetworks";
        const client = new IndividualUserFunctionClient();
        const promise = client.get(clientId, FunctionName);

        promise
            .onSuccess((data) => {
                this.setState({ hasNetworkPermission: data });
            })
            .onError(() => {
                this.setState({ hasNetworkPermission: false });
            });
    }

    public render(): JSX.Element {
        if (!checkPermission(UserClaim.AdviserPortalNetworkAndFirmReadWrite)) {return null;}
        return (
            <>
                <h3>Network</h3>
                <div className="row">
                    <div className="col-sm-8 col-12">
                        <SelectEditor
                            label="Network type"
                            options={[NetworkType.ServiceProvider, NetworkType.Network]}
                            getText={(v) => {
                                if (v == NetworkType.ServiceProvider) {return "Service provider";}
                                return "Network";
                            }}
                            placeholder="Please select"
                            onChange={(v) => this.setState({ createType: v })}
                        />
                    </div>
                    <div className="col-sm-4 col-12">
                        <button
                            className="btn primary mt-30"
                            disabled={!this.state.hasNetworkPermission}
                            onClick={() => {
                                const { createType } = this.state;
                                if (this.state.hasNetworkPermission && createType) {
                                    NetworkAction.createNetworkInstruction(
                                        {
                                            NetworkProcessType: NetworkProcessType.NetworkSetup,
                                            NetworkType: createType,
                                        },
                                        (data) => {
                                            Navigator.navigateTo(
                                                createType == NetworkType.ServiceProvider
                                                    ? Urls.get().ServiceProviderNetworkWizard
                                                    : Urls.get().NetworkDetailsWizard,
                                                {
                                                    scrollAfterNavigating: true,
                                                    queryParamsObject: { id: data.Id },
                                                }
                                            );
                                        }
                                    );
                                }
                            }}
                        >
                            Create
                        </button>
                    </div>
                </div>
                {this.renderFilter()}
                {this.state.selectNetwork && this.renderSelectedNetwork()}
                {this.renderTable()}
            </>
        );
    }

    private renderSelectedNetwork() {
        const { selectNetwork } = this.state;
        return (
            <div className="row">
                <div className="col-xs-6 col-sm-3">
                    <div className="form-group">
                        <h3 className="text-bold">Selected Network</h3>
                        <div className="controls">{selectNetwork.NetworkName}</div>
                    </div>
                </div>

                <div className="col-auto col-bottom">
                    <div className="form-group">
                        <button
                            className="btn secondary mr-10"
                            onClick={() => this.state.hasNetworkPermission && this.onClickEdit()}
                            disabled={!this.state.hasNetworkPermission}
                        >
                            Edit this network
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private onClickEdit() {
        const networkType = this.state.selectNetwork.NetworkType;
        const NetworkId = this.state.selectNetwork.Network;
        NetworkAction.createNetworkInstruction(
            { NetworkType: networkType, NetworkId: NetworkId, NetworkProcessType: NetworkProcessType.EditNetwork },
            (data) => {
                Navigator.navigateTo(
                    networkType == NetworkType.ServiceProvider
                        ? Urls.get().ServiceProviderNetworkWizard
                        : Urls.get().NetworkDetailsWizard,
                    {
                        scrollAfterNavigating: true,
                        queryParamsObject: { id: data.Id },
                    }
                );
            }
        );
    }

    private renderTable() {
        const { tableData, currentPage, filter, isLoading } = this.state;
        return (
            <NetworkHistoryTable
                tableData={tableData}
                currentPage={currentPage}
                pageSize={filter.Count}
                isLoading={isLoading}
                handlePageChange={this.handlePageChange}
                onSelectNetwork={(v) => this.setState({ selectNetwork: v })}
            />
        );
    }
    private renderFilter(): JSX.Element {
        const { filter } = this.state;
        return (
            <NetworkFilterDashboard
                filter={filter}
                handleFilterChange={this.handleFilterChange}
                onSearch={this.onSearch}
            />
        );
    }

    handleFilterChange = (changes: Dictionary[]) => {
        const updatedfilter = this.state.filter;
        for (const key in changes) {
            updatedfilter[key] = changes[key];
        }
        console.log(updatedfilter);
        this.setState({ filter: updatedfilter });
    };

    handlePageChange = (pageIndex: number) => {
        this.setState({ currentPage: pageIndex });
        this.getData(pageIndex);
    };

    private onNetworkStoreChange() {
        const data = NetworkStore.getData();
        this.setState({ tableData: data, isLoading: false });
    }

    onSearch = () => {
        this.setState({ currentPage: 1, selectNetwork: null });
        this.getData(1);
    };

    private getData(pageIndex: number): void {
        const query = this.getQuery(pageIndex);
        this.setState({ isLoading: true });
        NetworkAction.getNetwork(query);
    }

    private getQuery(pageIndex: number): any {
        const { filter } = this.state;
        const start = (pageIndex - 1) * filter.Count + 1;
        const query = JSON.parse(JSON.stringify(filter));
        query.Min = start;
        query.Max = start + 9;
        return query;
    }
}
